import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IDeposit, IWallet, IWithdraw } from "./types/_wallet";
const api = new APIClient();

const path = '/secured/wallet';
const walletApi = {
  wallets(params: any): Promise<AxiosResponse<ResponseData<IWallet[]> & PaginationResponse, any>> {
    const url = `${path}/get`
    return api.get(url, params)
  },
  getAllWallets(params: any): Promise<AxiosResponse<ResponseData<IWallet[]> & PaginationResponse, any>> {
    const url = `${path}/get`;
    return api.get(url, params)
  },
  centralWallet(params: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `${path}/getCentralWallet`;
    return api.get(url, params)
  },
  postWallet(dataForm: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `${path}/create`;
    return api.post(url, dataForm)
  },
  putWallet(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  deleteWallet(id: string | number): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `${path}/${id}/delete`;
    return api.delete(url);
  },
  postSwap(dataForm: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `${path}/swapv2`;
    return api.post(url, dataForm)
  },
  postDeposit(dataForm: any): Promise<AxiosResponse<ResponseData<IDeposit>, any>> {
    const url = `${path}/increaseV2`;
    return api.post(url, dataForm)
  },
  postWithdraw(dataForm: any): Promise<AxiosResponse<ResponseData<IWithdraw>, any>> {
    const url = `${path}/decreaseV2`;
    return api.post(url, dataForm)
  },
  getPositionMint(params: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/getListPositionMint`
    return api.get(url, params)
  },
  getPoolTokenBalance(params: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/getPoolTokenBalance`
    return api.get(url, params)
  },

  postBot(dataForm: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `/secured/bot/create`;
    return api.post(url, dataForm)
  },
  postBotTrade(dataForm: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `/secured/bot/createBotTrade`;
    return api.post(url, dataForm)
  },
  postBotProvideLiquidity(dataForm: any): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `/secured/bot/createBotProvideLiqudity`;
    return api.post(url, dataForm)
  },
  runBot(id: string | number): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `/secured/bot/start?id=${id}`;
    return api.post(url, {})
  },
  pauseBot(id: string | number): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `/secured/bot/stop?id=${id}`;
    return api.post(url, {})
  },
  stopBot(id: string | number): Promise<AxiosResponse<ResponseData<IWallet>, any>> {
    const url = `/secured/bot/forceStop?id=${id}`;
    return api.post(url, {})
  },
}
export default walletApi
